import Error from 'shared/pages/error/error.page';
import Maintenance from 'shared/pages/maintenance/maintenance.page';
import VatAgeCheck from 'shared/pages/vat-age-check/vat-age-check.page';
import type { NamedFC } from 'shared/types/named-fc.types';

import ChooseClub from 'ui/pages/choose-club/choose-club.page';
import ChooseMemberType from 'ui/pages/choose-member-type/choose-member-type.page';
import ChooseMembership from 'ui/pages/choose-membership/choose-membership.page';
import Confirmation from 'ui/pages/confirmation/confirmation.page';
import CustomizeMembership from 'ui/pages/customize-membership/customize-membership.page';
import Payment from 'ui/pages/payment/payment.page';
import PaymentStatus from 'ui/pages/payment-status/payment-status.page';
import Register from 'ui/pages/register/register.page';

import AppDownloadRedirect from '../functions/app-download-redirect/app-download-redirect.page';
import FriendOfStaffLanding from '../functions/friend-of-staff/friend-of-staff-landing/friend-of-staff-landing.page';
import PayOnOwnDevicePayment from '../functions/pay-on-own-device/pay-on-own-device-payment/pay-on-own-device-payment.page';
import Login from '../functions/shared-functions/auth/login.page';

/** This export is automatically generated. */
export const pages: Record<string, NamedFC> = {
  AppDownloadRedirect,
  ChooseClub,
  ChooseMemberType,
  ChooseMembership,
  Confirmation,
  CustomizeMembership,
  Error,
  FriendOfStaffLanding,
  Login,
  Maintenance,
  PayOnOwnDevicePayment,
  Payment,
  PaymentStatus,
  Register,
  VatAgeCheck,
};
